export default __webpack_public_path__ + "static/media/inheritance.94807b39.gif";